import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { ContactModel } from "./contact.model";
import { ContactService } from "./contact.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ContactInvoicesComponent } from './contact-invoices.component';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogDeleteComponent } from './contact-dialog-delete.component';
import { ContactDialogTComponent } from './contact-dialog-t.component';
import { ContactConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { ActualSelected, Utils } from '../../../shared/utils';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { ContactImportComponent } from './contact-import.component';
import { ContactBankAccountListComponent } from '../contactbankaccounts/contactbankaccount-list.component';
import { CenterListComponent } from '../center/center-list.component';
import { consts } from '../../../consts';
import { TableService } from '../../../shared/components/table/table.service';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { AccountingAccountsDialogLedgerComponent } from '../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import { Subscription } from 'rxjs';
import { ConsultantService } from '../../consultant/consultant.service';
import { RegisterModel } from '../../../core/authentication/register/register.model';
import { BookingContactSyncDialogComponent } from './booking-contact-sync-dialog.component';

@Component({
    selector: 'convfact-contact-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})

export class ContactListComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  filterView: any;

  constructor(
    private router: Router,
    private contactService: ContactService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dummy: DummyComponent,
    public userCompanyService: UserCompanyService,
    private tableService: TableService,
    private accountingAccountsService: AccountingAccountsService,
    private consultantService: ConsultantService,
  ) { }

  dataSource: ContactModel[];
  all: string[] = [];
  empty = false;
  ready = false;
  userCompany: UserCompanyModel = new UserCompanyModel();

  headerTable: any[] = ContactConst.headerTable;

  filter: string = '';

  showCreateUserOption: boolean = ActualSelected.isConsultant;

  // Interacción con la tabla
  onCompanyNameClick(contact) {
    this.edit(contact.uid);
  }

  onEntranceAccountClientClick(contact) {
    this.mayorContableCliente(contact.uid);
  }

  onEntranceAccountProviderClick(contact) {
    this.mayorContableProveedor(contact.uid);
  }

  // ------------------------

  public export(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.contactService.export().then(response =>
      FileSaver.saveAs(response, Utils.GetExcelName("Contactos")))
  }

  public openContactInvoices(uid: string, client: boolean, provider: boolean): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(ContactInvoicesComponent, {
      height: '80%',
      width: '80%',
      data: { uid: uid, isClient: client, isProvider: provider }
    });
  }

  public openContactT(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    let accountingAccount: ContactModel;
    for (let i = 0; i < this.dataSource.length; i++) {
      if (this.dataSource[i].uid === uid) {
        accountingAccount = this.dataSource[i];
      }
    }

    this.dialog.open(ContactDialogTComponent, {
      height: '80%',
      width: '80%',
      data: {
        uid: uid,
        clientAccount: accountingAccount.accountNumberClient,
        providerAccount: accountingAccount.accountNumberProvider
      }
    });
  }

  public contactBankAccounts(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(ContactBankAccountListComponent, {
      width: '500px',
      maxWidth: '96vw',
      maxHeight: '85vh',
      data: { uid: uid }
    });
  }

  public listCenters(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    let showFaceFields = false;
    const contactSelected = this.dataSource.find(x => x.uid === uid);
    if (contactSelected) {

      if (contactSelected && contactSelected.isJuridical != undefined && contactSelected.isJuridical === true) {
        showFaceFields = true;
      }
      if (contactSelected && contactSelected.isPublicAdmin != undefined && contactSelected.isPublicAdmin === true) {
        showFaceFields = true;
      }

    }

    this.dialog.open(CenterListComponent, {
      data: { contactUid: uid, showFaceFields: showFaceFields }
    });
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public import() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(ContactImportComponent, {
      width: '760px',
      maxWidth: '96vw',
      maxHeight: '90vh'
    });
    //this.router.navigate(['/contactimport']);
  }

  public syncBookcit(contactUid: string): void {
    const contact = this.dataSource.find(c => c.uid === contactUid);
    this.dialog.open(BookingContactSyncDialogComponent, {
      width: '640px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      data: { contactUid, contactName: contact ? contact.companyName : '' }
    });
  }

  public create(uid: string = undefined): void {
    this.userCompanyService.loadData().then(response => {
      this.userCompany = response;
      if (this.userCompany.accountLength == 0) {
        this.displayInfo("Debe ajustar la longitud de sus cuentas contables antes de crear un contacto.");
      } else {
        ContactFormV2Component.open(this.dialog, { uid }).subscribe(result => {
          if (result) this.getList();
        });
      }
    })
  }

  public edit(uid: string): void {
    ContactFormV2Component.open(this.dialog, { uid }).subscribe(result => {
      if (result) this.getList();
    });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const isContactSystem = this.dataSource.find(contact => contact.uid == uid);
    if (isContactSystem != undefined && isContactSystem.system == true) {
      this.displayInfo('No se puede eliminar un contacto del sistema');
      return;
    }

    this.dialog.open(ContactDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(() =>
        this.dummy.redirectTo(this.router.url)
      );
  }

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  ngOnInit() {
    this.getList();

    this.subscription = this.tableService.onGetFilter().subscribe(value => {
      this.filter = value;
      this.getList()
    });
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  getList() {
    this.contactService.getSummary(this.currentPage, this.itemsPerPage, this.filterView).then(res => {
      this.tableService.set(res.values);
      this.dataSource = res.values;
      this.totalItems = res.total;
      if (this.dataSource.length === 0) {
        this.empty = true;
      } else {
        this.empty = false;
      }
      this.ready = true;
    });
  }

  report347() {
    this.ready = false;
    this.contactService.report347(consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Informe 347"));
      this.ready = true;
    });
  }

  public extractoContable(contactUid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.contactService.excelExtractoContable(contactUid)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Extracto contable"));

      }).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel');

      });
  }

  public mayorContableCliente(contactUid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    let accountNumberContact: string = "";
    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel = new AccountingAccountsModel();

    const contactFind = this.dataSource.find(x => x.uid === contactUid);
    if (contactFind) {
      accountNumberContact = contactFind.accountNumberClient;
    }

    if (accountNumberContact) {
      this.accountingAccountsService.list(0, 1, accountNumberContact)
        .subscribe((x: any) => {
          accountingModelsResponse = x.data;

          if (accountingModelsResponse && accountingModelsResponse.length === 1) {
            accountingModels = accountingModelsResponse[0];
          }

          this.dialog.open(AccountingAccountsDialogLedgerComponent, {
            width: '700px',
            maxWidth: '96vw',
            
            maxHeight: '90vh',
            autoFocus: false,
            data: {
              id: accountingModels.id,
              name: accountingModels.name,
              number: accountingModels.number
            }
          });

        },
          err => {
            this.displayInfo("Este contacto no dispone de cuenta contable de cliente.")
          });
    }
    else {
      this.displayInfo("Este contacto no dispone de cuenta contable de cliente.")
    }


  }

  public mayorContableProveedor(contactUid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    let accountNumberContact: string = "";
    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel = new AccountingAccountsModel();

    const contactFind = this.dataSource.find(x => x.uid === contactUid);
    if (contactFind) {
      accountNumberContact = contactFind.accountNumberProvider;
    }

    if (accountNumberContact) {
      this.accountingAccountsService.list(0, 1, accountNumberContact)
        .subscribe((x: any) => {
          accountingModelsResponse = x.data;

          if (accountingModelsResponse && accountingModelsResponse.length === 1) {
            accountingModels = accountingModelsResponse[0];
          }

          this.dialog.open(AccountingAccountsDialogLedgerComponent, {
            width: '700px',
            maxWidth: '96vw',
            
            maxHeight: '90vh',
            autoFocus: false,
            data: {
              id: accountingModels.id,
              name: accountingModels.name,
              number: accountingModels.number
            }
          });

        },
          err => {
            this.displayInfo("Este contacto no dispone de cuenta contable de proveedor.")
          });
    } else {
      this.displayInfo("Este contacto no dispone de cuenta contable de proveedor.")
    }


  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  public createUser(contactUid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const contactFind = this.dataSource.find(x => x.uid === contactUid);

    if (contactFind) {

      const register: RegisterModel = {
        CompanyName: contactFind.companyName,
        VatNumber: contactFind.vatNumber,
        Username: contactFind.email,
        Password: '',
        Country: contactFind.country,
        ProvinceCode: contactFind.provinceCode,
        IsConsultant: false,
        Newsletter: false,
        State: contactFind.state,
        Name: '',
        Uid: consts.EMPTY_GUID,
        ParametrizationId: this.getParametrization(contactFind.vatNumber),
        PhoneNumber: contactFind.phone,
        countriesCode: contactFind.countriesCode,
      };

      this.consultantService.registerUser(register)
        .subscribe(result => {
          this.displayInfo(result['message']);

        }, err => {
          this.displayInfo(err['error']['message']);
        });

    }

  }

  private getParametrization(vatNumber: string): number {
    const juridical: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'N', 'R', 'U', 'V', 'W'];
    const physical: string[] = ['X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    if (physical.filter(value => value.startsWith(vatNumber.charAt(0).toUpperCase())).length > 0) {
      return 3;
    }
    else if (juridical.filter(value => value.startsWith(vatNumber.charAt(0).toUpperCase())).length > 0) {
      return 2;
    }
    else {
      return 1003;
    }

  }

  onSearch(filter: any) {
    this.filterView = filter;
    this.getList();
  }

}
